import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-23-avatar.png";
import BgOption1 from "../images/bg-option-1.png";
import BgOption2 from "../images/bg-option-2.png";
import BgOption3 from "../images/bg-option-3.png";
import TemplateImage from "./template-image.png";

import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic23 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #23";
    this.id = "23";
    this.url = "/ai/carousels/basic-23";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#37474F",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },

        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#1ACD8A",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Instrument Serif",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Instrument Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "HOW TO WRITE HOOK THAT DON'T SUCK",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "72px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 500)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "KEEP IT SHORT",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Your hook should fit on one line and get a point across quickly.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "TAP INTO EMOTIONS",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Make your readers feel something when they read your first line.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "ADDRESS A PROBLEM",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "60px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Start with one problem or challenge your reader faces and offer the solution in the body of your post.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "18px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "SHARE YOUR THOUGHTS IN THE COMMENTS",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "72px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getSecondaryColorVariant(common_settings) {
    return this.getSecondaryColor(common_settings) + "60";
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "50";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Instrument Serif";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Instrument Sans";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 px-[24px] flex flex-col gap-[20px]">
          <div className="flex flex-col gap-4">
            <div className="leading-[72px]">
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
          </div>
        </div>
        <svg
          width="97"
          height="20"
          viewBox="0 0 97 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute top-[412px] left-[32px]"
        >
          <path
            d="M20 10.2715C19.9397 12.8956 18.89 15.3646 16.7644 17.3557C15.7925 18.2662 14.6695 18.9393 13.4193 19.3929C12.0507 19.8904 10.5899 20.0826 9.1393 19.9559C7.68869 19.8292 6.2833 19.3867 5.02156 18.6595C4.92447 18.6036 4.846 18.6213 4.75437 18.6548C3.57485 19.0849 2.39532 19.5167 1.21407 19.9408C0.863685 20.0665 0.540869 19.9904 0.276656 19.7286C0.00871841 19.463 -0.0672676 19.1375 0.060369 18.7815C0.489467 17.5835 0.923034 16.3871 1.36107 15.1924C1.37514 15.1587 1.38069 15.1221 1.37723 15.0857C1.37376 15.0494 1.36139 15.0144 1.34121 14.984C0.912669 14.2471 0.582648 13.457 0.359595 12.6342C0.0714628 11.591 -0.0428892 10.5074 0.0211344 9.42699C0.151585 7.27478 0.89398 5.36025 2.24832 3.68341C3.33422 2.34179 4.68831 1.35223 6.29222 0.712482C7.66774 0.160784 9.14935 -0.075481 10.6281 0.021055C14.4555 0.256582 17.8163 2.67595 19.2632 6.24166C19.7514 7.44389 19.9898 8.69681 20 10.2715Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M55.2253 0.45459C52.1855 0.45459 50.5003 2.62897 50.5003 2.62897C50.5003 2.62897 48.815 0.45459 45.7753 0.45459C42.5854 0.45459 40.0002 3.01598 40.0002 6.17663C40.0002 10.516 45.1579 14.7212 46.5953 16.0498C48.2512 17.5791 50.5003 19.5454 50.5003 19.5454C50.5003 19.5454 52.7494 17.5791 54.4052 16.0498C55.8427 14.7212 61.0003 10.516 61.0003 6.17663C61.0003 3.01598 58.4152 0.45459 55.2253 0.45459Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M96.2734 18.4153C96.2734 18.8843 95.7403 19.1543 95.3622 18.8769L88.9757 14.1911C88.7742 14.0433 88.4999 14.0433 88.2984 14.1911L81.9119 18.8769C81.5338 19.1543 81.0007 18.8843 81.0007 18.4153V1.0271C81.0007 0.710912 81.2571 0.45459 81.5732 0.45459H95.7009C96.0171 0.45459 96.2734 0.710912 96.2734 1.0271V18.4153Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
        </svg>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div className="absolute inset-x-0 top-[100px] px-[32px] flex flex-col gap-[12px]">
        <div className="leading-[60px]">
          {slide.elements[0]?.style ? (
            <MultilineView
              element={slide.elements[0]}
              getPropertyByStyleKey={(styleKey) =>
                this.getPropertyByStyleKey(styleKey, commonSettings)
              }
              getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
            />
          ) : (
            <TextView text={slide.elements[0]?.value} />
          )}
        </div>

        {slide.elements[1]?.style ? (
          <MultilineView
            element={slide.elements[1]}
            getPropertyByStyleKey={(styleKey) =>
              this.getPropertyByStyleKey(styleKey, commonSettings)
            }
            getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
          />
        ) : (
          <TextView text={slide.elements[1]?.value} />
        )}
      </div>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        {slide.elements[1]?.value && (
          <>
            <img
              className="absolute top-0 left-0 w-[400px] h-[500px] object-cover"
              src={slide.elements[1].value}
              alt=""
            />

            <div
              className="absolute top-0 left-0 w-[400px] h-[500px]"
              style={{
                backgroundImage: `linear-gradient(${this.getPrimaryColor(
                  commonSettings
                )},${this.getBackgroundColor(commonSettings)})`,
                opacity: "0.6",
              }}
            ></div>
          </>
        )}

        <div className="absolute inset-x-0 px-[24px] flex flex-col items-center gap-[20px]">
          <div className="flex flex-col gap-4">
            <div className="leading-[72px]">
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
          </div>
        </div>

        <div className="absolute top-[432px] left-[32px] flex items-center gap-2">
          <img
            className="object-cover w-[36px] h-[36px] rounded-full"
            src={
              commonSettings.elements[1].value.image
                ? commonSettings.elements[1].value.image
                : LogoPlaceholder
            }
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
            }}
            alt=""
          />
          <p
            className="text-[18px] font-semibold leading-[28px]"
            style={{
              color: this.getSecondaryColor(commonSettings),
              fontFamily: this.getSecondaryFont(commonSettings),
            }}
          >
            {commonSettings.elements[0].value}
          </p>
        </div>

        <svg
          width="400"
          height="8"
          viewBox="0 0 400 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute bottom-0 left-0 w-full h-2"
        >
          <mask id="path-1-inside-1_2436_1093" fill="white">
            <path d="M0 0H400V8H0V0Z" />
          </mask>
          <path
            d="M0 0H400V8H0V0Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M400 -4H396.97V4H400V-4ZM390.909 -4H384.848V4H390.909V-4ZM378.788 -4H372.727V4H378.788V-4ZM366.667 -4H360.606V4H366.667V-4ZM354.545 -4H348.485V4H354.545V-4ZM342.424 -4H336.364V4H342.424V-4ZM330.303 -4H324.242V4H330.303V-4ZM318.182 -4H312.121V4H318.182V-4ZM306.061 -4H300V4H306.061V-4ZM293.939 -4H287.879V4H293.939V-4ZM281.818 -4H275.758V4H281.818V-4ZM269.697 -4H263.636V4H269.697V-4ZM257.576 -4H251.515V4H257.576V-4ZM245.455 -4H239.394V4H245.455V-4ZM233.333 -4H227.273V4H233.333V-4ZM221.212 -4H215.151V4H221.212V-4ZM209.091 -4H203.03V4H209.091V-4ZM196.97 -4H190.909V4H196.97V-4ZM184.848 -4H178.788V4H184.848V-4ZM172.727 -4H166.667V4H172.727V-4ZM160.606 -4H154.545V4H160.606V-4ZM148.485 -4H142.424V4H148.485V-4ZM136.364 -4H130.303V4H136.364V-4ZM124.242 -4H118.182V4H124.242V-4ZM112.121 -4H106.061V4H112.121V-4ZM99.9999 -4H93.9393V4H99.9999V-4ZM87.8787 -4H81.8181V4H87.8787V-4ZM75.7575 -4H69.6969V4H75.7575V-4ZM63.6363 -4H57.5757V4H63.6363V-4ZM51.5151 -4H45.4545V4H51.5151V-4ZM39.3939 -4H33.3333V4H39.3939V-4ZM27.2727 -4H21.212V4H27.2727V-4ZM15.1514 -4H9.09083V4H15.1514V-4ZM3.0302 -4H0V4H3.0302V-4ZM400 -8H396.97V8H400V-8ZM390.909 -8H384.848V8H390.909V-8ZM378.788 -8H372.727V8H378.788V-8ZM366.667 -8H360.606V8H366.667V-8ZM354.545 -8H348.485V8H354.545V-8ZM342.424 -8H336.364V8H342.424V-8ZM330.303 -8H324.242V8H330.303V-8ZM318.182 -8H312.121V8H318.182V-8ZM306.061 -8H300V8H306.061V-8ZM293.939 -8H287.879V8H293.939V-8ZM281.818 -8H275.758V8H281.818V-8ZM269.697 -8H263.636V8H269.697V-8ZM257.576 -8H251.515V8H257.576V-8ZM245.455 -8H239.394V8H245.455V-8ZM233.333 -8H227.273V8H233.333V-8ZM221.212 -8H215.151V8H221.212V-8ZM209.091 -8H203.03V8H209.091V-8ZM196.97 -8H190.909V8H196.97V-8ZM184.848 -8H178.788V8H184.848V-8ZM172.727 -8H166.667V8H172.727V-8ZM160.606 -8H154.545V8H160.606V-8ZM148.485 -8H142.424V8H148.485V-8ZM136.364 -8H130.303V8H136.364V-8ZM124.242 -8H118.182V8H124.242V-8ZM112.121 -8H106.061V8H112.121V-8ZM99.9999 -8H93.9393V8H99.9999V-8ZM87.8787 -8H81.8181V8H87.8787V-8ZM75.7575 -8H69.6969V8H75.7575V-8ZM63.6363 -8H57.5757V8H63.6363V-8ZM51.5151 -8H45.4545V8H51.5151V-8ZM39.3939 -8H33.3333V8H39.3939V-8ZM27.2727 -8H21.212V8H27.2727V-8ZM15.1514 -8H9.09083V8H15.1514V-8ZM3.0302 -8H0V8H3.0302V-8Z"
            fill={this.getBackgroundColor(commonSettings)}
            mask="url(#path-1-inside-1_2436_1093)"
          />
        </svg>
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col items-center justify-center w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        <svg
          width="400"
          height="8"
          viewBox="0 0 400 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute bottom-0 left-0 w-full h-2"
        >
          <mask id="path-1-inside-1_2436_1093" fill="white">
            <path d="M0 0H400V8H0V0Z" />
          </mask>
          <path
            d="M0 0H400V8H0V0Z"
            fill={this.getPrimaryColor(commonSettings)}
          />
          <path
            d="M400 -4H396.97V4H400V-4ZM390.909 -4H384.848V4H390.909V-4ZM378.788 -4H372.727V4H378.788V-4ZM366.667 -4H360.606V4H366.667V-4ZM354.545 -4H348.485V4H354.545V-4ZM342.424 -4H336.364V4H342.424V-4ZM330.303 -4H324.242V4H330.303V-4ZM318.182 -4H312.121V4H318.182V-4ZM306.061 -4H300V4H306.061V-4ZM293.939 -4H287.879V4H293.939V-4ZM281.818 -4H275.758V4H281.818V-4ZM269.697 -4H263.636V4H269.697V-4ZM257.576 -4H251.515V4H257.576V-4ZM245.455 -4H239.394V4H245.455V-4ZM233.333 -4H227.273V4H233.333V-4ZM221.212 -4H215.151V4H221.212V-4ZM209.091 -4H203.03V4H209.091V-4ZM196.97 -4H190.909V4H196.97V-4ZM184.848 -4H178.788V4H184.848V-4ZM172.727 -4H166.667V4H172.727V-4ZM160.606 -4H154.545V4H160.606V-4ZM148.485 -4H142.424V4H148.485V-4ZM136.364 -4H130.303V4H136.364V-4ZM124.242 -4H118.182V4H124.242V-4ZM112.121 -4H106.061V4H112.121V-4ZM99.9999 -4H93.9393V4H99.9999V-4ZM87.8787 -4H81.8181V4H87.8787V-4ZM75.7575 -4H69.6969V4H75.7575V-4ZM63.6363 -4H57.5757V4H63.6363V-4ZM51.5151 -4H45.4545V4H51.5151V-4ZM39.3939 -4H33.3333V4H39.3939V-4ZM27.2727 -4H21.212V4H27.2727V-4ZM15.1514 -4H9.09083V4H15.1514V-4ZM3.0302 -4H0V4H3.0302V-4ZM400 -8H396.97V8H400V-8ZM390.909 -8H384.848V8H390.909V-8ZM378.788 -8H372.727V8H378.788V-8ZM366.667 -8H360.606V8H366.667V-8ZM354.545 -8H348.485V8H354.545V-8ZM342.424 -8H336.364V8H342.424V-8ZM330.303 -8H324.242V8H330.303V-8ZM318.182 -8H312.121V8H318.182V-8ZM306.061 -8H300V8H306.061V-8ZM293.939 -8H287.879V8H293.939V-8ZM281.818 -8H275.758V8H281.818V-8ZM269.697 -8H263.636V8H269.697V-8ZM257.576 -8H251.515V8H257.576V-8ZM245.455 -8H239.394V8H245.455V-8ZM233.333 -8H227.273V8H233.333V-8ZM221.212 -8H215.151V8H221.212V-8ZM209.091 -8H203.03V8H209.091V-8ZM196.97 -8H190.909V8H196.97V-8ZM184.848 -8H178.788V8H184.848V-8ZM172.727 -8H166.667V8H172.727V-8ZM160.606 -8H154.545V8H160.606V-8ZM148.485 -8H142.424V8H148.485V-8ZM136.364 -8H130.303V8H136.364V-8ZM124.242 -8H118.182V8H124.242V-8ZM112.121 -8H106.061V8H112.121V-8ZM99.9999 -8H93.9393V8H99.9999V-8ZM87.8787 -8H81.8181V8H87.8787V-8ZM75.7575 -8H69.6969V8H75.7575V-8ZM63.6363 -8H57.5757V8H63.6363V-8ZM51.5151 -8H45.4545V8H51.5151V-8ZM39.3939 -8H33.3333V8H39.3939V-8ZM27.2727 -8H21.212V8H27.2727V-8ZM15.1514 -8H9.09083V8H15.1514V-8ZM3.0302 -8H0V8H3.0302V-8Z"
            fill={this.getBackgroundColor(commonSettings)}
            mask="url(#path-1-inside-1_2436_1093)"
          />
        </svg>

        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}

        {index !== carouselLength - 1 && (
          <p
            className="absolute top-[32px] left-[342px] text-[14px] font-medium leading-[20px]"
            style={{
              color: this.getSecondaryColor(commonSettings),
              fontFamily: this.getSecondaryFont(commonSettings),
            }}
          >
            {index + 1}/{carouselLength}
          </p>
        )}

        {index !== 0 && (
          <>
            <div className="absolute top-[32px] left-[32px] flex items-center gap-2">
              <img
                className="object-cover w-[24px] h-[24px] rounded-full"
                src={
                  commonSettings.elements[1].value.image
                    ? commonSettings.elements[1].value.image
                    : LogoPlaceholder
                }
                style={{
                  backgroundColor: this.getPrimaryColor(commonSettings),
                }}
                alt=""
              />
              <p
                className="text-[18px] font-semibold leading-[28px]"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                  fontFamily: this.getSecondaryFont(commonSettings),
                }}
              >
                {commonSettings.elements[0].value}
              </p>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Basic23;
